import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Settings } from '../models/Settings';
import { FoodPortalStateService } from '../services/food-portal-state.service';
import { Splashscreen } from '../models/splashscreen';
import { determineStorageUrl } from '../common/storage-tools';

@Component({
    selector: 'pi-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    standalone: false
})
export class SplashScreenComponent implements OnInit {

  loading: Observable<boolean>;
  showEnterButton: Observable<boolean>;
  logoStorageUrl = determineStorageUrl() + '/user-photos/food-portal-logos/';
  @Input() settings: Settings;


  constructor(private state: FoodPortalStateService) { }

  ngOnInit() {
    this.settings = this.state.portalSettings;
  }

  get splashScreenImage() {
    return this.settings.selectedSplashScreenImage === Splashscreen.custom ? this.logoStorageUrl + this.settings.splashScreenImage :
      `assets/splash-bg-${this.settings.selectedSplashScreenImage}.jpg`;
  }

  disclaimerBtnClick() {

  }

}
